import {nombreDeAcciones} from "constantes/nombreDeAcciones";
import dayjs from 'dayjs'

const initialState = {
    departamentos: [],
    politicalsOrganizations: [],
    rangoDeEdades: [],
    tiposDeCirculacionDelMedio: [],
    tipoDeMedioEscrito: [],
    tipoDeDistribucionDelMedio: [],
    tipoDeVallasFijas: [],
    tipoSentidoDeVisualizacion: [],
    tipoDeTransporte: [],
    tipoDeMedioDeComunicacion: [],
    catalogos:{municipios:[]},
    corporacionesDeTelevision: [],
    corporacionesDeRadio: [],
    corporacionesDeEscritos: [],
    idOpGeneral: "",
    monthIndex: dayjs(dayjs(new Date(nombreDeAcciones.FECHA_INICIAL)).month()),
    presupuestoPlanDeMedios: [],
    tarifaPlanDeMedios: [],
    presupuestoGastado: [],
    fechasDeOrdenes: [],
};

export default (state = initialState, action ) => {
    switch (action.type) {
        case nombreDeAcciones.SETEAR_RANGO_DE_EDADES:
            return {
                ...state,
                rangoDeEdades: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPOS_DE_CIRCULACION_DEL_MEDIO:
            return {
                ...state,
                tiposDeCirculacionDelMedio: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPO_DE_MEDIOS_ESCRITO:
            return {
                ...state,
                tipoDeMedioEscrito: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPO_DE_DISTRIBUCION_DEL_MEDIO:
            return {
                ...state,
                tipoDeDistribucionDelMedio: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPO_DE_VALLAS_FIJAS:
            return {
                ...state,
                tipoDeVallasFijas: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPO_DE_VISUALIZACION:
            return {
                ...state,
                tipoSentidoDeVisualizacion: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPO_DE_TRANSPORTE:
            return {
                ...state,
                tipoDeTransporte: action.payload,
            }
        case nombreDeAcciones.SETEAR_TIPO_DE_MEDIO_DE_COMUNICACION:
            return {
                ...state,
                tipoDeMedioDeComunicacion: action.payload,
            }
        case nombreDeAcciones.SETEAR_REGISTROS_PLAN_DE_MEDIOS_TELEVISION:
            console.log("SETEAR_REGISTROS_PLAN_DE_MEDIOS_TELEVISION", action.payload)
            return {
                ...state,
                corporacionesDeTelevision: action.payload,
            }
        case nombreDeAcciones.SETEAR_REGISTROS_PLAN_DE_MEDIOS_RADIO:
            console.log("SETEAR_REGISTROS_PLAN_DE_MEDIOS_RADIO", action.payload)
            return {
                ...state,
                corporacionesDeRadio: action.payload,
            }
        case nombreDeAcciones.SETEAR_REGISTROS_PLAN_DE_MEDIOS_ESCRITOS:
            console.log("SETEAR_REGISTROS_PLAN_DE_MEDIOS_ESCRITOS", action.payload)
            return {
                ...state,
                corporacionesDeEscritos: action.payload,
            }
        case nombreDeAcciones.SETEARINDICE:
            return {
                ...state,
                monthIndex: action.payload,
            }
        case nombreDeAcciones.OBTENER_DEPARTAMENTOS:
            return {
                ...state,
                departamentos: action.payload,
            }
        case nombreDeAcciones.OBTENER_MUNICIPIOS:
            let newState = Object.assign({}, state);
            newState.catalogos.municipios= state.catalogos.municipios.length > 0 ? state.catalogos.municipios.concat(action.payload) : action.payload;
            return newState;
        case nombreDeAcciones.LIMPIAR_LOS_MUNICIPIOS:
            let copiaState = Object.assign({}, state);
            copiaState.catalogos.municipios= action.payload;
            return copiaState;
        case nombreDeAcciones.GET_POLITICALSORGANIZATIONS:
            return {
                ...state,
                politicalsOrganizations: action.payload,
            }
        case nombreDeAcciones.SET_DATA_IDOP:
            return {
                ...state,
                idOpGeneral: action.payload,
            }
        case nombreDeAcciones.SETEAR_PRESUPUESTO_PLAN_DE_MEDIOS:
            return {
                ...state,
                presupuestoPlanDeMedios: action.payload,
            }
        case nombreDeAcciones.SETEAR_TARIFAS_PLAN_DE_MEDIOS:
            return {
                ...state,
                tarifaPlanDeMedios: action.payload,
            }
        case nombreDeAcciones.SETEAR_PRESUPUESTO_GASTADO:
            return {
                ...state,
                presupuestoGastado: action.payload,
            }
        case nombreDeAcciones.SETEAR_FECHAS_ORDENES:
            return {
                ...state,
                fechasDeOrdenes: action.payload,
            }
        default:
            return state;
    }
}